export default __webpack_public_path__ + "0e3c13dfcd729ca1fd4c74675da6cf58.png";